import React, { useEffect, useState, useCallback } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import SearchIcon from "@mui/icons-material/Search";
import { IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import apiClient from "../../BaseUrl/apiClient.js"
import "../../css/App.css";
import "../../css/color.css";
import _ from "lodash";
import {DISPLAY_PAGE_SIZE} from "../../constants/constants"
import TokenService from "../../service/TokenService";
import SriyanshCardHeader from "../../components/CardHeader";
import EncryptService from "../../service/EncryptionService";
import CircularProgress from "@mui/material/CircularProgress";
import ExportToExcelCustomButton from "../../components/ExportToExcelButtonCustom";
import ExportToPDFCustomButton from "../../components/ExportPDFfromTable.js";
import ListDynamicTable from "../../CustomComponant/ListDynamicTable";
import SearchTextField from "../../CustomComponant/SearchTextField";

//import { DataTable } from "../../constantVaribles/constatanvariable.js";

function POList() {
  const [pageLoader, setPageLoader] = useState(false);
  const [returnData, setReturnData] = useState([]);
  const [reportData, setReportData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [srcinddata, setSrcinddata] = useState("");
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1); // set the current page
  const pageSize = DISPLAY_PAGE_SIZE;
  const tokenServiceDetails = TokenService.getUserDetails();
  const uname = tokenServiceDetails?.uname;
  const deleteip = EncryptService.decrypt(sessionStorage.getItem("token1"));
  

  const handleRowClick = (row) => {
    // Handle row click action with the row data
    viewData(row.entrynumber);
    // console.log('Row data:', row);
  };

  const handlEditClick = (row) => {
    // Handle row click action with the row data
    EditData(row.entrynumber);
    //console.log('Row data:', row);
  };

  const handlDeleteClick = (row) => {
    // Handle row click action with the row data
   // deleteData(row.entrynumber);
   //console.log('Row data:', row);

    const isConfirmed = window.confirm(`Are you sure you want to delete Indent Number : ${row.indentnumber}`);
    if (isConfirmed) {
      deleteData(row.indentnumber);
    } else {
      alert('Delete action cancelled.');
      return;
    }






  };

  // Debounced search function
  const fetchData = useCallback(
    _.debounce(async (searchTerm) => {
      try {
       // setPageLoader(true);
        const response = await apiClient.post("/getAllIndentList", {
          uname: uname,
          limit: String(pageSize * (currentPage - 1)),
          offset: String(pageSize),
          srcinddata: searchTerm,
        });
        setReturnData(response.data);
        setTotalRows(response.data[0]?.totaldata || 0);

        const allDataResponse = await apiClient.post("/getAllIndentList", {
          uname: uname,
          limit: "0", // No limit
          offset: "0", // No offset
          srcinddata: "", // No search term for fetching all data
        });

        setReportData(allDataResponse.data);
        //DataTable(reportData);
      } catch (error) {
        setReportData([]);
        setReturnData([]);
        setTotalRows(0);
      }finally
      {
        setPageLoader(false);
      }
    }, 300),
    [uname, currentPage, pageSize]
  );

  useEffect(() => {
    fetchData(srcinddata);
    return () => {
    fetchData.cancel(); // ✅ VERY IMPORTANT
  };
  }, [srcinddata, fetchData]);

  const viewData = (e) => {
    navigate("poentry", {
      state: {
        indent_id: e,
      },
    });
  };

  const EditData = (e) => {
    navigate("indentedit", {
      state: {
        indent_id: e,
      },
    });
  };

  const deleteData = async (e) => {
    //  setError("You want to delete Data ");

//console.log("Delete Indent Number:", e);


    try {
      const response = await apiClient.post("/deleteIndentData", {
        indentnumber: e,
        uname: uname,
        ip: deleteip,
      });

     // alert(e);
      navigate('../', { replace: true });

    } catch (error) {
      //setError(error);
      alert(error);
    }
  };

  const columns = [`Shop`, "indentnumber", "indreceiptdate", "daydiff", "itemname",'IndentInPO',"urgency"]; // keys from your data objects
  const columnNames = [
    "Consignee",
    "Indent Number",
    "Indent Date",
    "Pending Days from Indent",
    "Item Name",
    'Part PO Genereted',
    "Urgency",

  ];

  return (
    <div>
      {/* <SriyanshCardHeader Title="Indent List which PO Not Found" /> */}

      <Card className="Formcard">
      <div className="input-groupHeading">
      Indent List which PO Not Generated

            </div>


        <CardContent>
          {/*-----------------------SEARCH BOX--------------------*/}
          {currentPage === 1 ? (
            <SearchTextField
              label="Indent Number"
              value={srcinddata}
              title="Enter Indent Number"
              onChange={(e) => setSrcinddata(e.target.value)}
              adornment={
                <IconButton title="Search PO">
                  <SearchIcon />
                </IconButton>
              }
            />
          ) : null}

          {/* ------------------------------LIST of Data ----------------------------*/}

          {pageLoader ? (
            <div className="loaderContainer">
              {" "}
              <CircularProgress />{" "}
            </div>
          ) : (
            <ListDynamicTable
              columns={columns}
              columnNames={columnNames}
              data={returnData}
              totalRows={totalRows}
              pageSize={pageSize}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              onEditClick={handlEditClick}
              onDeleteClick={handlDeleteClick}
              onRowClick={handleRowClick}
              colorConditionColumn="IndentInPO"
              colorConditionValue="Yes"
            />
          )}

          {/* -----------------------Export Button---------------------------------------- */}
          <div className="container mt-4"></div>

          <div className=" container mb-3 mt-2 col-12 gap-4 d-flex justify-content-center">
            <ExportToExcelCustomButton
              data={reportData}
              fileName={"POList"} //+ `${currentPage}`}
              columns={columns}
              columnNames={columnNames}
              buttonTitle="Export to Excel"
            />

            <ExportToPDFCustomButton
              data={reportData}
              fileName={"POList"}
              columns={columns}
              columnNames={columnNames}
              buttonTitle="Export to PDF"
              pageHeader="Indent List which PO Not Found"
            />

            {/* <ExporttoPDFButton
              tableComponent={reportData}
              fileName={"POList PAGE NO. :" + `${currentPage}`}
              buttonTitle="Export to PDF"
              pageOrientation="l"
            /> */}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export default POList;
